import { computed } from 'mobx';

/**
 * 모델
 * @window w_tb_e028
 * @category 지역등록
 */

export class RegionModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 검사담당부서
   *
   * **data type** varchar(2)
   */
  gareacd: string;

  /**
   * 코드
   *
   * **data type** varchar(4)
   */
  areacd: string;

  /**
   * 지역명
   *
   * **data type** varchar(20)
   */
  areanm: string;

  /**
   * 그룹지역명
   *
   * **data type** varchar(20)
   */
  abbnm: string;

  /**
   * 담당자
   *
   * **data type** char(10)
   */
  perid: string;

  /**
   * 순번
   *
   * **data type** float
   */
  seq: string;

  /**
   * 사용유무
   *
   * **data type** char(1)
   */
  useyn: string;

  /**
   * 비고
   *
   * **data type** varchar(100)
   */
  remark: string;

  /**
   * 입력자
   *
   * **data type** varchar(10)
   */
  inperid: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  indate: string;

  /**
   * ??
   *
   * **data type** varchar(20)
   */
  divicd: string;

  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.gareacd = data.gareacd || '';
    this.areacd = data.areacd || '';
    this.areanm = data.areanm || '';
    this.abbnm = data.abbnm || '';
    this.perid = data.perid || '';
    this.seq = data.seq || '';
    this.useyn = data.useyn || '';
    this.remark = data.remark || '';
    this.inperid = data.inperid || '';
    this.indate = data.indate || '';
    this.divicd = data.divicd || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
